export const TERMS_LAST_UPDATED = 'October 22, 2026';
export const PRIVACY_LAST_UPDATED = 'March 1, 2026';
export const CUSTOMER_POLICIES_LAST_UPDATED = 'October 26, 2026';
